import { render, staticRenderFns } from "./userBuyNum.vue?vue&type=template&id=4a00062c&"
import script from "./userBuyNum.vue?vue&type=script&lang=js&"
export * from "./userBuyNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports